import { render, staticRenderFns } from "./ActivitiesOnboardingModal.vue?vue&type=template&id=841a0966&scoped=true&"
import script from "./ActivitiesOnboardingModal.vue?vue&type=script&lang=js&"
export * from "./ActivitiesOnboardingModal.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesOnboardingModal.vue?vue&type=style&index=0&id=841a0966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841a0966",
  null
  
)

export default component.exports